<hawk-record-navigation
  class="app-page"
  *ngIf="user"
  [breadcrumbLinkList]="[
    { link: '/a/benutzer', description: 'Nutzer' },
    { link: '/a/benutzer/' + user.id, description: user.full_name },
  ]"
  [root]="'user'"
  [leafDescription]="'Passwort neu setzen'"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center"></div>
  <div class="page-content px-4 pb-2 overflow-auto">
    <form class="page-sheet max-w-sm mx-auto" [formGroup]="passwordForm" (submit)="onSubmit()">
      <fieldset class="bm-fieldset">
        <label class="bm-fieldset-label">Neues Passwort</label>
        <input type="password" class="bm-input w-full" formControlName="new_password" />
        <div *ngIf="passwordForm.controls['password_confirm'].errors?.required">
          Bitte geben SIe ein neues Passwort ein
        </div>

        <label class="bm-fieldset-label">Passwort Wiederholung</label>
        <input type="password" class="bm-input w-full" formControlName="password_confirm" />
        <div *ngIf="passwordForm.controls['password_confirm'].errors?.required">Bitte bestätigen Sie das Passwort</div>
        <div *ngIf="passwordForm.controls['password_confirm'].errors?.confirmedValidator">
          Die beiden Passwörter stimmen nicht überein
        </div>

        <label class="bm-fieldset-label">
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="sendEmail" [ngModelOptions]="{ standalone: true }" />
          Passwort per E-Mail ({{ user.email1 }}) zusenden
        </label>
      </fieldset>

      <div class="flex flex-row items-center justify-end gap-2 mt-4">
        <a [routerLink]="'/benutzer/' + user.id" class="bm-btn"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!passwordForm.valid">Passwort speichern</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>
